import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-box-list my-3"></div>
`;

export class WCBoxList extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcBoxList = clone.content.querySelector('.wc-box-list');
    if (this.hasAttribute('id')) {
      wcBoxList.id = this.getAttribute('id');
    }
    contentNodes.forEach(node => {
      wcBoxList.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcBoxList);
  }

}